import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";
import routes from "./views/routes";
import { store } from "./redux/store";
import MaterialTheme from "./views/components/MaterialTheme";

const App = () => {
  return (
    <Provider store={store}>
      <MaterialTheme>
        <RouterProvider router={routes} />
      </MaterialTheme>
    </Provider>
  );
};

export default App;
